import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IntlManager } from '@atlas/core';
import { Icon } from '@atlas/ui';

import { CDN_TYPE_BASE, imageUrlCDN } from 'common/utils/utils';

const MAX_VISIBLE_ITEMS = 5;

const QuickDepositPaymentMethodDropdown = ({ onSelect, paymentMethod, paymentMethods }) => {
  const listRef = useRef(null);
  const selectedItemRef = useRef(null);

  useEffect(() => {
    const item = selectedItemRef.current;
    const list = listRef.current;

    if (!item || !list) return;

    list.scrollTop = item.offsetTop - list.clientHeight / 2 + item.offsetHeight / 2;
  }, []);

  const showFade = paymentMethods.length > MAX_VISIBLE_ITEMS;

  return (
    <div
      className={cx('quick-deposit-pm-dropdown', {
        'quick-deposit-pm-dropdown_scrollable': showFade,
      })}
    >
      <div className="quick-deposit-pm-dropdown__list" ref={listRef}>
        {paymentMethods.map(pm => {
          const isSelected = pm.id === paymentMethod?.id;
          const imageStyle = pm.desktopImageLink
            ? { backgroundImage: `url(${imageUrlCDN(pm.desktopImageLink, CDN_TYPE_BASE)})` }
            : {};

          return (
            <button
              className={cx('quick-deposit-pm-dropdown__item', {
                'quick-deposit-pm-dropdown__item_active': isSelected,
              })}
              key={pm.id}
              onClick={() => onSelect(pm)}
              ref={isSelected ? selectedItemRef : null}
              type="button"
            >
              <span className="quick-deposit-pm-dropdown__logo" style={imageStyle}>
                {!pm.desktopImageLink && <Icon name="money" />}
              </span>
              <span className="quick-deposit-pm-dropdown__info">
                <span className="quick-deposit-pm-dropdown__name">{pm.name}</span>
                {pm.minAmount !== undefined && pm.maxAmount !== undefined && (
                  <span className="quick-deposit-pm-dropdown__limits">
                    Min: <span className="quick-deposit-pm-dropdown__limits-value">{IntlManager.formatMoney(pm.minAmount)}</span>
                    {' — '}
                    Max: <span className="quick-deposit-pm-dropdown__limits-value">{IntlManager.formatMoney(pm.maxAmount)}</span>
                  </span>
                )}
              </span>
              {isSelected && (
                <Icon
                  className="quick-deposit-pm-dropdown__check"
                  height={16}
                  name="selected-check"
                  width={16}
                />
              )}
            </button>
          );
        })}
      </div>
      {showFade && <div aria-hidden="true" className="quick-deposit-pm-dropdown__fade" />}
    </div>
  );
};

QuickDepositPaymentMethodDropdown.propTypes = {
  onSelect: PropTypes.func.isRequired,
  paymentMethod: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  paymentMethods: PropTypes.arrayOf(
    PropTypes.shape({
      desktopImageLink: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      maxAmount: PropTypes.number,
      minAmount: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
};

export default QuickDepositPaymentMethodDropdown;
